"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMccCodeValues = exports.MCC_CODE_BY_ENUM = exports.LODGING_MCC_BLOCK = exports.AUTOMOBILE_RENTAL_MCC_BLOCK = exports.AIRLINES_MCC_BLOCK = exports.MccCode = void 0;
/** DO NOT EXPORT THESE CONTS!  use MccCode and MCC_CODE_BY_ENUM in the rest of the codebase */
const GROCERIES_AND_SUPERMARKETS_MCC_CODE = '5411';
const MISCELLANEOUS_FOOD_STORES_MCC_CODE = '5499';
const SERVICE_STATIONS_MCC_CODE = '5541';
const AUTOMATED_FUEL_DISPENSERS_MCC_CODE = '5542';
const RESTAURANTS_MCC_CODE = '5812';
const FAST_FOOD_MCC_CODE = '5814';
const HOME_SUPPLY_WAREHOUSE_STORES_MCC_CODE = '5200';
const UTILITIES_MCC_CODE = '4900';
const CABLE_MCC_CODE = '4899';
const GENERAL_CONTRACTORS_MCC_CODE = '1520';
const HEATING_PLUMBING_AND_AIR_CONDITIONING_MCC_CODE = '1711';
const ELECTRICAL_CONTRACTORS_MCC_CODE = '1731';
const MASONRY_AND_TILE_SETTING_MCC_CODE = '1740';
const CARPENTRY_CONTRACTORS_MCC_CODE = '1750';
const ROOFING_AND_SIDING_MCC_CODE = '1761';
const CONCRETE_WORK_MCC_CODE = '1771';
const SPECIAL_TRADE_CONTRACTORS_MCC_CODE = '1799';
const BUILDING_MATERIALS_AND_LUMBER_MCC_CODE = '5211';
const GLASS_PAINT_AND_WALLPAPER_MCC_CODE = '5231';
const HARDWARE_STORES_MCC_CODE = '5251';
const LAWN_AND_GARDEN_SUPPLY_MCC_CODE = '5261';
const FLOOR_COVERING_STORES_MCC_CODE = '5713';
const DRAPERY_AND_WINDOW_COVERING_MCC_CODE = '5714';
const FIREPLACE_AND_FIREPLACE_SCREENS_MCC_CODE = '5718';
const EV_CHARGING_MCC_CODE = '5552';
const RAILROADS_MCC_CODE = '4011';
const COMMUTER_TRANSPORTATION_INCLUDING_FERRIES_MCC_CODE = '4111';
const PASSENGER_RAILWAYS_MCC_CODE = '4112';
const TAXICABS_AND_LIMOUSINES_MCC_CODE = '4121';
const STEAMSHIP_AND_CRUISE_LINES_MCC_CODE = '4411';
const AIRLINES_NOT_ELSEWHERE_CLASSIFIED_MCC_CODE = '4511';
const TRAVEL_AGENCIES_AND_TOUR_OPERATORS_MCC_CODE = '4722';
const TOLLS_AND_BRIDGE_FEES_MCC_CODE = '4784';
const TRANSPORTATION_SERVICES_NOT_ELSEWHERE_CLASSIFIED_MCC_CODE = '4789';
const LODGING_HOTELS_AND_MOTELS_MCC_CODE = '7011';
const AUTOMOBILE_RENTAL_AGENCIES_MCC_CODE = '7512';
const PARKING_LOTS_AND_GARAGES_MCC_CODE = '7523';
var MccCode;
(function (MccCode) {
    MccCode["GROCERIES_AND_SUPERMARKETS"] = "GROCERIES_AND_SUPERMARKETS";
    MccCode["MISCELLANEOUS_FOOD_STORES"] = "MISCELLANEOUS_FOOD_STORES";
    MccCode["SERVICE_STATIONS"] = "SERVICE_STATIONS";
    MccCode["AUTOMATED_FUEL_DISPENSERS"] = "AUTOMATED_FUEL_DISPENSERS";
    MccCode["RESTAURANTS"] = "RESTAURANTS";
    MccCode["FAST_FOOD"] = "FAST_FOOD";
    MccCode["HOME_SUPPLY_WAREHOUSE_STORES"] = "HOME_SUPPLY_WAREHOUSE_STORES";
    MccCode["UTILITIES"] = "UTILITIES";
    MccCode["CABLE"] = "CABLE";
    MccCode["GENERAL_CONTRACTORS"] = "GENERAL_CONTRACTORS";
    MccCode["HEATING_PLUMBING_AND_AIR_CONDITIONING"] = "HEATING_PLUMBING_AND_AIR_CONDITIONING";
    MccCode["ELECTRICAL_CONTRACTORS"] = "ELECTRICAL_CONTRACTORS";
    MccCode["MASONRY_AND_TILE_SETTING"] = "MASONRY_AND_TILE_SETTING";
    MccCode["CARPENTRY_CONTRACTORS"] = "CARPENTRY_CONTRACTORS";
    MccCode["ROOFING_AND_SIDING"] = "ROOFING_AND_SIDING";
    MccCode["CONCRETE_WORK"] = "CONCRETE_WORK";
    MccCode["SPECIAL_TRADE_CONTRACTORS"] = "SPECIAL_TRADE_CONTRACTORS";
    MccCode["BUILDING_MATERIALS_AND_LUMBER"] = "BUILDING_MATERIALS_AND_LUMBER";
    MccCode["GLASS_PAINT_AND_WALLPAPER"] = "GLASS_PAINT_AND_WALLPAPER";
    MccCode["HARDWARE_STORES"] = "HARDWARE_STORES";
    MccCode["LAWN_AND_GARDEN_SUPPLY"] = "LAWN_AND_GARDEN_SUPPLY";
    MccCode["FLOOR_COVERING_STORES"] = "FLOOR_COVERING_STORES";
    MccCode["DRAPERY_AND_WINDOW_COVERING"] = "DRAPERY_AND_WINDOW_COVERING";
    MccCode["FIREPLACE_AND_FIREPLACE_SCREENS"] = "FIREPLACE_AND_FIREPLACE_SCREENS";
    MccCode["EV_CHARGING"] = "EV_CHARGING";
    MccCode["RAILROADS"] = "RAILROADS";
    MccCode["COMMUTER_TRANSPORTATION_INCLUDING_FERRIES"] = "COMMUTER_TRANSPORTATION_INCLUDING_FERRIES";
    MccCode["PASSENGER_RAILWAYS"] = "PASSENGER_RAILWAYS";
    MccCode["TAXICABS_AND_LIMOUSINES"] = "TAXICABS_AND_LIMOUSINES";
    MccCode["STEAMSHIP_AND_CRUISE_LINES"] = "STEAMSHIP_AND_CRUISE_LINES";
    MccCode["AIRLINES_NOT_ELSEWHERE_CLASSIFIED"] = "AIRLINES_NOT_ELSEWHERE_CLASSIFIED";
    MccCode["TRAVEL_AGENCIES_AND_TOUR_OPERATORS"] = "TRAVEL_AGENCIES_AND_TOUR_OPERATORS";
    MccCode["TOLLS_AND_BRIDGE_FEES"] = "TOLLS_AND_BRIDGE_FEES";
    MccCode["TRANSPORTATION_SERVICES_NOT_ELSEWHERE_CLASSIFIED"] = "TRANSPORTATION_SERVICES_NOT_ELSEWHERE_CLASSIFIED";
    MccCode["LODGING_HOTELS_AND_MOTELS"] = "LODGING_HOTELS_AND_MOTELS";
    MccCode["AUTOMOBILE_RENTAL_AGENCIES"] = "AUTOMOBILE_RENTAL_AGENCIES";
    MccCode["PARKING_LOTS_AND_GARAGES"] = "PARKING_LOTS_AND_GARAGES";
    MccCode["AIRLINES_ISSUER_BLOCK"] = "AIRLINES_ISSUER_BLOCK";
    MccCode["AUTOMOBILE_RENTAL_ISSUER_BLOCK"] = "AUTOMOBILE_RENTAL_ISSUER_BLOCK";
    MccCode["LODGING_ISSUER_BLOCK"] = "LODGING_ISSUER_BLOCK";
})(MccCode || (exports.MccCode = MccCode = {}));
exports.AIRLINES_MCC_BLOCK = { firstMccCode: '3000', lastMccCode: '3308' };
exports.AUTOMOBILE_RENTAL_MCC_BLOCK = { firstMccCode: '3351', lastMccCode: '3441' };
exports.LODGING_MCC_BLOCK = { firstMccCode: '3501', lastMccCode: '3883' };
exports.MCC_CODE_BY_ENUM = {
    [MccCode.GROCERIES_AND_SUPERMARKETS]: GROCERIES_AND_SUPERMARKETS_MCC_CODE,
    [MccCode.MISCELLANEOUS_FOOD_STORES]: MISCELLANEOUS_FOOD_STORES_MCC_CODE,
    [MccCode.SERVICE_STATIONS]: SERVICE_STATIONS_MCC_CODE,
    [MccCode.AUTOMATED_FUEL_DISPENSERS]: AUTOMATED_FUEL_DISPENSERS_MCC_CODE,
    [MccCode.RESTAURANTS]: RESTAURANTS_MCC_CODE,
    [MccCode.FAST_FOOD]: FAST_FOOD_MCC_CODE,
    [MccCode.HOME_SUPPLY_WAREHOUSE_STORES]: HOME_SUPPLY_WAREHOUSE_STORES_MCC_CODE,
    [MccCode.UTILITIES]: UTILITIES_MCC_CODE,
    [MccCode.CABLE]: CABLE_MCC_CODE,
    [MccCode.GENERAL_CONTRACTORS]: GENERAL_CONTRACTORS_MCC_CODE,
    [MccCode.HEATING_PLUMBING_AND_AIR_CONDITIONING]: HEATING_PLUMBING_AND_AIR_CONDITIONING_MCC_CODE,
    [MccCode.ELECTRICAL_CONTRACTORS]: ELECTRICAL_CONTRACTORS_MCC_CODE,
    [MccCode.MASONRY_AND_TILE_SETTING]: MASONRY_AND_TILE_SETTING_MCC_CODE,
    [MccCode.CARPENTRY_CONTRACTORS]: CARPENTRY_CONTRACTORS_MCC_CODE,
    [MccCode.ROOFING_AND_SIDING]: ROOFING_AND_SIDING_MCC_CODE,
    [MccCode.CONCRETE_WORK]: CONCRETE_WORK_MCC_CODE,
    [MccCode.SPECIAL_TRADE_CONTRACTORS]: SPECIAL_TRADE_CONTRACTORS_MCC_CODE,
    [MccCode.BUILDING_MATERIALS_AND_LUMBER]: BUILDING_MATERIALS_AND_LUMBER_MCC_CODE,
    [MccCode.GLASS_PAINT_AND_WALLPAPER]: GLASS_PAINT_AND_WALLPAPER_MCC_CODE,
    [MccCode.HARDWARE_STORES]: HARDWARE_STORES_MCC_CODE,
    [MccCode.LAWN_AND_GARDEN_SUPPLY]: LAWN_AND_GARDEN_SUPPLY_MCC_CODE,
    [MccCode.FLOOR_COVERING_STORES]: FLOOR_COVERING_STORES_MCC_CODE,
    [MccCode.DRAPERY_AND_WINDOW_COVERING]: DRAPERY_AND_WINDOW_COVERING_MCC_CODE,
    [MccCode.FIREPLACE_AND_FIREPLACE_SCREENS]: FIREPLACE_AND_FIREPLACE_SCREENS_MCC_CODE,
    [MccCode.EV_CHARGING]: EV_CHARGING_MCC_CODE,
    [MccCode.RAILROADS]: RAILROADS_MCC_CODE,
    [MccCode.COMMUTER_TRANSPORTATION_INCLUDING_FERRIES]: COMMUTER_TRANSPORTATION_INCLUDING_FERRIES_MCC_CODE,
    [MccCode.PASSENGER_RAILWAYS]: PASSENGER_RAILWAYS_MCC_CODE,
    [MccCode.TAXICABS_AND_LIMOUSINES]: TAXICABS_AND_LIMOUSINES_MCC_CODE,
    [MccCode.STEAMSHIP_AND_CRUISE_LINES]: STEAMSHIP_AND_CRUISE_LINES_MCC_CODE,
    [MccCode.AIRLINES_NOT_ELSEWHERE_CLASSIFIED]: AIRLINES_NOT_ELSEWHERE_CLASSIFIED_MCC_CODE,
    [MccCode.TRAVEL_AGENCIES_AND_TOUR_OPERATORS]: TRAVEL_AGENCIES_AND_TOUR_OPERATORS_MCC_CODE,
    [MccCode.TOLLS_AND_BRIDGE_FEES]: TOLLS_AND_BRIDGE_FEES_MCC_CODE,
    [MccCode.TRANSPORTATION_SERVICES_NOT_ELSEWHERE_CLASSIFIED]: TRANSPORTATION_SERVICES_NOT_ELSEWHERE_CLASSIFIED_MCC_CODE,
    [MccCode.LODGING_HOTELS_AND_MOTELS]: LODGING_HOTELS_AND_MOTELS_MCC_CODE,
    [MccCode.AUTOMOBILE_RENTAL_AGENCIES]: AUTOMOBILE_RENTAL_AGENCIES_MCC_CODE,
    [MccCode.PARKING_LOTS_AND_GARAGES]: PARKING_LOTS_AND_GARAGES_MCC_CODE,
    [MccCode.AIRLINES_ISSUER_BLOCK]: exports.AIRLINES_MCC_BLOCK,
    [MccCode.AUTOMOBILE_RENTAL_ISSUER_BLOCK]: exports.AUTOMOBILE_RENTAL_MCC_BLOCK,
    [MccCode.LODGING_ISSUER_BLOCK]: exports.LODGING_MCC_BLOCK,
};
/** MCC codes are always four digits; a block declares the inclusive range of codes it accepts. */
const expandMccBlock = ({ firstMccCode, lastMccCode }) => {
    const first = Number(firstMccCode);
    const last = Number(lastMccCode);
    if (!Number.isInteger(first) || !Number.isInteger(last) || first > last) {
        throw new Error(`Invalid MCC block ${firstMccCode}-${lastMccCode}`);
    }
    // A block stands in for hundreds of codes that have no named members; every value it produces is
    // validated above to be a four-digit code in the declared range.
    return Array.from({ length: last - first + 1 }, (_, offset) => String(first + offset).padStart(4, '0'));
};
/**
 * The numeric MCC codes a named set matches on or stores.
 *
 * A named set mixes single codes and blocks, so this is the one place a name becomes numbers: a member is
 * looked up in MCC_CODE_BY_ENUM, a block expands to its range. Everything that persists a boost's codes or
 * compares against CoreCard's raw MCC value goes through here.
 */
const toMccCodeValues = (entries) => entries.flatMap((entry) => {
    const mapped = exports.MCC_CODE_BY_ENUM[entry];
    return typeof mapped === 'string' ? [mapped] : expandMccBlock(mapped);
});
exports.toMccCodeValues = toMccCodeValues;
